import { useEffect, useState } from 'react';
import './WordDisplay.css';

export const WordDisplay = ({ word, animKey }) => {
  const [visible, setVisible] = useState(false);

  const animTrigger = animKey ?? word;
  useEffect(() => {
    setVisible(false);
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, [animTrigger]);

  return (
    <div className="word-display">
      <div className={`word-display__card ${visible ? 'word-display__card--visible' : ''}`}>
        <span className="word-display__text">{word}</span>
      </div>
    </div>
  );
};
